import React from "react";
import plaidIcon from "../../assets/images/plaidLogo1.png";

export const PlaidLoadingMessage = ({ title, description, progress = 0, compact = false }) => (
  <div
    className={`plaid-loading-banner${
      compact ? " plaid-loading-banner--compact" : ""
    }`}
    role="status"
    aria-live="polite"
  >
    <div className="plaid-loading-banner__indicator">
      <span className="plaid-loading-banner__dot" />
      <span className="plaid-loading-banner__dot" />
      <span className="plaid-loading-banner__dot" />
    </div>
    <div className="plaid-loading-banner__content">
      <div className="plaid-loading-banner__title">{title}</div>
      {description && (
        <div className="plaid-loading-banner__description">{description}</div>
      )}
      {progress > 0 && (progress < 100) && (
        <div className="plaid-loading-banner__progress-container">
          <div 
            className="plaid-loading-banner__progress-bar" 
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  </div>
);

export const PlaidStatusLoader = ({ title = "Securely Connecting", subtitle = "Syncing your bank data...", progress = 0, isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="plaid-status-loader" role="status" aria-live="polite">
      <div className="plaid-status-loader__card">
        <div className="plaid-status-loader__animation">
          <div className="plaid-status-loader__ring" />
          <div className="plaid-status-loader__active-ring" />
          <div className="plaid-status-loader__icon">
            <img src={plaidIcon} alt="Plaid" />
          </div>
        </div>
        <div className="plaid-status-loader__content">
          <h3 className="plaid-status-loader__title">{title}</h3>
          <p className="plaid-status-loader__subtitle">{subtitle}</p>
          
          {progress > 0 && (
            <div className="plaid-status-loader__progress-shell">
              <div className="plaid-status-loader__progress-track">
                <div 
                  className="plaid-status-loader__progress-fill" 
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const PlaidAccountsSkeleton = () => (
  <div className="plaid-skeleton-stack" aria-hidden="true">
    {[0, 1].map((group) => (
      <div className="plaid-skeleton-group" key={group}>
        <div className="plaid-skeleton shimmer plaid-skeleton-bank-title" />
        <div className="plaid-skeleton-table">
          <div className="plaid-skeleton-table__header">
            {[0, 1, 2, 3, 4].map((column) => (
              <div
                className="plaid-skeleton shimmer plaid-skeleton-table__header-cell"
                key={column}
              />
            ))}
          </div>
          {[0, 1, 2].map((row) => (
            <div className="plaid-skeleton-table__row" key={row}>
              {[0, 1, 2, 3, 4].map((column) => (
                <div
                  className="plaid-skeleton shimmer plaid-skeleton-table__cell"
                  key={column}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export const PlaidApiStatusSkeleton = () => (
  <div className="plaid-api-status-grid" aria-hidden="true">
    {[0, 1, 2, 3, 4].map((card) => (
      <div className="plaid-api-status-card plaid-api-status-card--skeleton" key={card}>
        <div className="plaid-api-status-card__top">
          <div className="plaid-skeleton shimmer plaid-api-status-skeleton__label" />
          <div className="plaid-skeleton shimmer plaid-api-status-skeleton__pill" />
        </div>
        <div className="plaid-skeleton shimmer plaid-api-status-skeleton__meta" />
        <div className="plaid-skeleton shimmer plaid-api-status-skeleton__meta plaid-api-status-skeleton__meta--short" />
        <div className="plaid-skeleton shimmer plaid-api-status-skeleton__api" />
      </div>
    ))}
  </div>
);

export const PlaidBankSearchSkeleton = () => (
  <div className="plaid-bank-search-skeleton" aria-hidden="true">
    {[0, 1, 2, 3, 4].map((item) => (
      <div className="plaid-bank-card-skeleton" key={item}>
        <div className="plaid-skeleton shimmer plaid-bank-card-skeleton__icon" />
        <div className="plaid-bank-card-skeleton__content">
          <div className="plaid-skeleton shimmer plaid-bank-card-skeleton__title" />
          <div className="plaid-skeleton shimmer plaid-bank-card-skeleton__subtitle" />
        </div>
      </div>
    ))}
  </div>
);

export const PlaidButtonSpinner = ({ color = "#ffffff" }) => (
  <div className="plaid-button-spinner">
    <div className="plaid-button-spinner__ring" style={{ borderColor: `${color} transparent transparent transparent` }}></div>
  </div>
);
